<template>
  <div class="box">
    <div class="title-container is-flex is-centered payments">
      <h2 class="title is-4 has-text-primary title-invoice-payments">
        Pagos
      </h2>

      <span
        v-if="paymentsExpired"
        class="tag is-danger"
      >
        Los pagos expiraron
      </span>
      <span
        v-else
        class="tag is-success"
      >
        Los pagos aún estan vigentes
      </span>
    </div>
    <b-table
      :data="payments"
      mobile-cards
    >
      <template slot-scope="props">
        <b-table-column
          field="amount"
          label="Monto"
        >
          {{ props.row.amount | toCurrency(props.row.currency) }}
        </b-table-column>

        <b-table-column
          field="currency"
          label="Fecha y hora"
        >
          {{ props.row.currency }}
        </b-table-column>

        <b-table-column
          field="date"
          label="Fecha"
          centered
        >
          {{ props.row.datetime | toHumanDate }}
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                icon="emoticon-sad"
                size="is-large"
              />
            </p>
            <p>Aún no hay pagos a esta factura</p>
          </div>
        </section>
      </template>
    </b-table>

    <h2 class="title is-4 has-text-primary pending-balance">
      Monto pendiente
    </h2>

    <div
      v-for="currency in paymentsCurrencies"
      :key="currency"
      class="pending-balance-amount"
    >
      {{ debt | toCurrency(currency) }}
    </div>
  </div>
</template>

<script>
import merge from 'lodash/merge';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapGetters } = createNamespacedHelpers('invoice');

export default {
  name: 'InvoicePayments',
  computed: merge(
    mapState({
      payments: ({ operation }) => operation.payments,
      debt: ({ operation }) => operation.debt,
    }),
    mapGetters(['paymentsCurrencies', 'paymentsExpired']),
  ),
};
</script>

<style scoped>
.title-container.is-flex.is-centered {
  justify-content: space-between!important;
}

.title-container.is-flex.is-centered.payments {
  padding-bottom: 1rem;
}

.title.is-4.has-text-primary.pending-balance {
  padding: 1rem 0;
}

.title {
  margin: 0;
}

.pending-balance-amount {
  padding: 8px 12px;
}
</style>
